import css from "../../css/common/modal.module.css";
import cssModal from "../../css/my-property/modal.module.css";

import React, { useState } from "react";
import PropTypes from "prop-types";
import Router from "next/router";
import ReactModal from "react-modal";
import Map from "./Map";
import {
    claimPropertyUser,
    claimPropertyManager,
    OWNER_TYPE,
    MANAGER_TYPE,
} from "../../service/my-property";
import classNames from "classnames";
import CloseIcon from "mdi-react/CloseIcon";
import Logo from "../header/Logo";

const MyPropertyModal = (props) => {
    const { address, geocodeData, onClose } = props;

    const [role, setRole] = useState(null);
    const [isSubmit, setIsSubmit] = useState(false);
    const [error, setError] = useState(null);

    const [listingUrl, setListingUrl] = useState(null);
    const [propertyUrl, setPropertyUrl] = useState(null);

    const handleRoleChange = (role) => {
        setRole(role);
        setIsSubmit(false);
        setError(null);
    };

    const handleSubmit = async () => {
        if (!role || !address || !geocodeData) {
            return null;
        }

        setIsSubmit(true);
        setListingUrl(null);
        setPropertyUrl(null);

        const request =
            role === OWNER_TYPE ? claimPropertyUser : claimPropertyManager;

        try {
            // request exists?
            await request(address);

            // redirect to User's property page
            Router.push("/user/my-properties");
        } catch (e) {
            let error = null;

            if (e && e.response && e.response.data && e.response.data.error) {
                let errors = {};

                for (let field in e.response.data.error) {
                    errors[field] = Object.values(e.response.data.error[field]);
                }

                if (errors.address) {
                    error = errors.address;
                }

                if (e.response.data.listing_url) {
                    setListingUrl(e.response.data.listing_url);
                }

                if (e.response.data.property_url) {
                    setPropertyUrl(e.response.data.property_url);
                }
            }

            setIsSubmit(false);
            setError(error);
        }
    };

    const handleListingUrl = () => {
        if (!listingUrl && !propertyUrl) {
            return;
        }

        const fullUrl = listingUrl ? `/l/${listingUrl}` : `/p/${propertyUrl}`;
        const pathname = listingUrl ? "/listing" : "/property";
        const query = listingUrl
            ? { listing: listingUrl }
            : { property: propertyUrl };

        Router.push({ pathname, query }, fullUrl);
    };

    return (
        <ReactModal
            isOpen={true}
            onRequestClose={onClose}
            className={css.modal}
            ariaHideApp={false}
        >
            <div className={css.modalContent}>
                <div className={css.logo}>
                    <Logo size="lg" />
                </div>

                <CloseIcon onClick={onClose} className={css.close} />

                <div>
                    <div className={css.header}>
                        <div className={css.headerLeft}>My Property</div>
                        <div
                            className={classNames({
                                [css.headerRight]: true,
                                [cssModal.headerRight]: true,
                            })}
                        >
                            <strong style={{ fontWeight: 300 }}>
                                {address}
                            </strong>
                        </div>
                    </div>

                    <div className={css.line} />

                    <div className={css.map}>
                        <Map
                            latitude={geocodeData.latitude}
                            longitude={geocodeData.longitude}
                            address={geocodeData.address}
                            showAddress={true}
                        />
                    </div>

                    <div className={cssModal.role}>
                        What is your desired Role for this property?
                        <br />
                        <div className={cssModal.group}>
                            <div className={cssModal.inputGroup}>
                                <label key="owner">
                                    <input
                                        type="radio"
                                        name="role"
                                        value={OWNER_TYPE}
                                        checked={role === OWNER_TYPE}
                                        onChange={() =>
                                            handleRoleChange(OWNER_TYPE)
                                        }
                                    />
                                    Owner
                                </label>
                                <label key="manager">
                                    <input
                                        type="radio"
                                        name="role"
                                        value={MANAGER_TYPE}
                                        checked={role === MANAGER_TYPE}
                                        onChange={() =>
                                            handleRoleChange(MANAGER_TYPE)
                                        }
                                    />
                                    Manager
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className={css.line} />

                    {error && (
                        <div>
                            <div className={cssModal.error}>
                                {error}
                                <br />
                                {(listingUrl || propertyUrl) && (
                                    <button
                                        type="button"
                                        className={css.submit2}
                                        onClick={handleListingUrl}
                                        style={{ marginTop: "10px" }}
                                    >
                                        View property
                                    </button>
                                )}
                            </div>
                            <div className={cssModal.errorHelp}>
                                If you have any trouble with the request
                                <br />
                                please call our support at 1-877-840-1780.
                            </div>
                        </div>
                    )}

                    {role && (
                        <button
                            type="button"
                            className={isSubmit ? css.submitting : css.submit}
                            onClick={handleSubmit}
                        >
                            {isSubmit ? (
                                <span>Please wait...</span>
                            ) : (
                                <span>
                                    {role === OWNER_TYPE ? (
                                        <>
                                            I own this Property.
                                            <br />
                                            SEND REQUEST TO RESIDENTIAL
                                        </>
                                    ) : (
                                        <>
                                            I want to be the manager of this
                                            property.
                                            <br />
                                            SEND REQUEST TO THE OWNER
                                        </>
                                    )}
                                </span>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </ReactModal>
    );
};

MyPropertyModal.propTypes = {
    address: PropTypes.string.isRequired,
    geocodeData: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default MyPropertyModal;
